import Loadable from '@townsquare/loadable';
import {
	aggGoalDirectoryArchivedRoute,
	aggGoalDirectoryFollowingRoute,
	aggGoalDirectoryRoute,
} from '@townsquare/routes/agg-goal-directory-view';
import { tqlExplainerAggResource } from '@townsquare/tql/agg/resource';

import { goalDirectoryAggResource } from './resources/goal-directory-agg';
import { goalDirectoryTableAggResource } from './resources/goal-directory-table-agg';

const GoalsDirectoryAggLoadable = Loadable({
	loader: () =>
		import(/* webpackChunkName: "agg-goals-directory-view" */ './components/GoalsDirectoryAgg'),
	loading: () => null,
});

aggGoalDirectoryRoute.component = GoalsDirectoryAggLoadable;
aggGoalDirectoryRoute.relayEnvironment = 'agg';
aggGoalDirectoryRoute.resources = [
	goalDirectoryAggResource,
	goalDirectoryTableAggResource,
	tqlExplainerAggResource,
];

aggGoalDirectoryFollowingRoute.component = GoalsDirectoryAggLoadable;
aggGoalDirectoryFollowingRoute.relayEnvironment = 'agg';
aggGoalDirectoryFollowingRoute.resources = [
	goalDirectoryAggResource,
	goalDirectoryTableAggResource,
	tqlExplainerAggResource,
];

aggGoalDirectoryArchivedRoute.component = GoalsDirectoryAggLoadable;
aggGoalDirectoryArchivedRoute.relayEnvironment = 'agg';
aggGoalDirectoryArchivedRoute.resources = [
	goalDirectoryAggResource,
	goalDirectoryTableAggResource,
	tqlExplainerAggResource,
];

export const aggGoalDirectoryRouterRoute = aggGoalDirectoryRoute;
export const aggGoalDirectoryFollowingRouterRoute = aggGoalDirectoryFollowingRoute;
export const aggGoalDirectoryArchivedRouterRoute = aggGoalDirectoryArchivedRoute;
